export default __webpack_public_path__ + "static/media/education.10cfa28a.svg";